<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title class="sticky-title"
          >Prozessinformationen bearbeiten</v-card-title
        >
        <v-container>
          <v-row class="mx-2">
            <v-col class="align-center justify-space-between" cols="12">
              <v-row align="center" class="mr-0">
                <v-text-field
                  v-if="
                    !processInformation || !processInformation.characteristic
                  "
                  :disabled="!canEdit"
                  placeholder="Name"
                  v-model="processInformation.fileName"
                ></v-text-field>
              </v-row>
              <v-row align="center" class="mr-0">
                <v-select
                  :disabled="!canEdit"
                  v-model="processInformation.folderId"
                  :items="folders"
                  item-text="folderName"
                  item-value="id"
                  label="Ordner wählen"
                  hint="Es können nur Ordner mit Schreibberechtigung gewählt werden"
                  persistent-hint
                ></v-select>
              </v-row>
              <v-row align="center" class="mr-0">
                <v-select
                  :disabled="!canEdit"
                  v-model="processInformation.initiator"
                  :items="users"
                  item-text="fullName"
                  item-value="userId"
                  label="Prozesseigentümer"
                  hint="Sie können den Prozess auf einen anderen Nutzer übertragen"
                  persistent-hint
                ></v-select>
              </v-row>
              <v-row align="center" class="mr-0">
                <v-text-field
                  :disabled="!canEdit"
                  v-model="processInformation.docNr"
                  label="Dokumentennummer"
                  hint="Dokumentennummer laut Managementhandbuch"
                  persistent-hint
                ></v-text-field>
              </v-row>
              <v-row align="center" class="mr-0">
                 <v-text-field
                  :disabled="!canEdit"
                  v-model="processInformation.mngmtLink"
                  label="Link zum Managementhandbuch"
                  hint="Hier den Link zum Prozess im Management-Handbuch einfügen"
                  persistent-hint
                ></v-text-field>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mx-2">
            <h4 style="align-self: center">Prozesssteckbrief:</h4>
            <v-icon v-if="processInformation.characteristic" color="success"
              >mdi-check-circle</v-icon
            >
            <v-icon v-if="!processInformation.characteristic" color="error"
              >mdi-close-circle</v-icon
            >
            <v-btn
              v-if="processInformation.characteristic && canEdit"
              small
              text
              @click.stop="editCharacteristics(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
            <v-btn
              v-if="processInformation.characteristic && !canEdit"
              small
              text
              @click.stop="viewCharacteristics(item)"
              >Ansehen</v-btn
            >

            <v-btn
              v-if="!processInformation.characteristic"
              text
              @click.stop="addCharacteristic"
              >Hinzufügen</v-btn
            >
          </v-row>
          <!--  <v-row class="mx-2">
          <h4 style="align-self:center;">Freigabeprozess: </h4>
          <v-switch :disabled="processInformation.reviewRequests != null && processInformation.reviewRequests.length > 0" style="margin-left: 10px;" v-model="processInformation.releaseEnabled" color="primary" inset></v-switch>
        </v-row> -->
        </v-container>
        <v-card-actions>
          <v-btn id="leftButton" text @click.stop="dialog = false"
            >Abbrechen</v-btn
          >
          <v-btn
            id="rightButton"
            color="primary"
            @click.stop="editProcessModel()"
            :disabled="
              processInformation.folderId == null ||
              processInformation.fileName == null
            "
            >Speichern</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ProcessCharacteristicsDialog
      :openFromProcess="true"
      ref="newCharacteristics"
    />
  </div>
</template>

<script>
import ProcessCharacteristics from "../ProcessMap/ProcessCharacteristics.vue";
import ProcessCharacteristicsDialog from "../ProcessMap/ProcessCharacteristicsDialog.vue";
import processMapService from "@/components/processMapService.js";
import processListService from "./processlist-service";
import userService from "@/components/userService";
import folderService from "@/components/folder-service";
export default {
  data() {
    return {
      processInformation: null,
      viewMode: false,
      canEdit: false,
      dialog: false,
      folders: null,
      users: null,
    };
  },
  watch: {
    addCharacteristic() {
      if (this.addCharacteristic) this.openCharacteristicDialog();
    },
  },
  methods: {
    open(processInformation, folders, viewMode, canEdit) {
      this.folders = folders;
      this.processInformation = processInformation;
      this.canEdit = canEdit;
      this.viewMode = viewMode;
      this.dialog = true;
      userService.retrieveUsers().then((res) => (this.users = res.data));
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close() {
      this.reject();
      this.dialog = false;
    },
    async submitFileName() {
      await processListService.editFileName(
        this.processInformation.uuid,
        this.processInformation.fileName
      );
    },
    async submitDocNr() {
      await processListService.editDocNr(
        this.processInformation.uuid,
        this.processInformation.docNr
      );
    },
    async submitMngmtLink() {
      await processListService.editMngmtLink(
        this.processInformation.uuid,
        this.processInformation.mngmtLink
      );
    },
    async submitProcessOwner() {
      await processListService.changeProcessOwner(
        this.processInformation.uuid,
        this.processInformation.initiator
      );
    },
    async submitFolderId() {
      await folderService.addProcessToFolder(this.processInformation.folderId, [
        this.processInformation.uuid,
      ]);
    },
    async editProcessModel() {
      await this.submitFileName();
      await this.submitProcessOwner();
      await this.changeReleaseState();
      await this.submitFolderId();
      await this.submitMngmtLink();
      await this.submitDocNr();
      this.resolve();
    },
    editCharacteristics() {
      this.$refs.newCharacteristics
        .open(this.processInformation.characteristic, !this.canEdit)
        .then((res) => {
          if (!res.connectedModelId) {
            res.connectedModelId = this.processInformation.uuid;
          }

          if (!this.processInformation.fileName) {
            this.processInformation.fileName = res.name;
          }
          res.name = this.processInformation.fileName;
          processMapService
            .updateProcessCharacteristic(res)
            .then((response) => {
              this.processInformation.characteristic = response.data;
              if (
                response.data &&
                response.data.connectedModelId != this.processInformation.uuid
              ) {
                window.location.reload();
              }
            });
        })
        .catch((e) => {
          if (e && e.connectedModelId != this.processInformation.uuid) {
            window.location.reload();
          }
        });
    },
    addCharacteristic() {
      this.$refs.newCharacteristics
        .open(null, false, this.processInformation.fileName)
        .then((characteristic) => {
          characteristic.connectedModelId = this.processInformation.uuid;
          this.processInformation.fileName = characteristic.name;
          processMapService
            .addProcessCharacteristic(characteristic)
            .then((res) => {
              this.processInformation.characteristic = res.data;
            });
        });
    },
    async changeReleaseState() {
      await processListService.changeReleaseState(
        this.processInformation.uuid,
        this.processInformation.releaseEnabled
      );
    },
  },
  components: { ProcessCharacteristics, ProcessCharacteristicsDialog },
};
</script>